import qzTrayClientSignerApi from "../../api/qztray/qzTrayClientSignerApi";

const QzTrayClientSignerService = {

  /**
   * Envía texto a firmar al backend y devuelve la firma en Base64.
   */
  signRaw: async (toSign: string) => {
    const response = await qzTrayClientSignerApi.add({ text: toSign });
    return response.data;
  },
};

export default QzTrayClientSignerService;
